import { useApiPrivateRequest } from "../hooks/useApi";
import { CompanyDocumentView } from "../models/CompanyDocument";

export const useSearchCompanyDocs = () => {
  const {
    data: results,
    call,
    isLoading: isSearching,
  } = useApiPrivateRequest<CompanyDocumentView[]>((response) =>
    response.map((result: any) => new CompanyDocumentView(result)),
  );
  const searchCompanyDocs = async (
    companyId: number,
    offset?: number,
    limit?: number,
    yearStart?: string,
    yearEnd?: string,
    type?: string,
  ) => {
    await call(`/companies/${companyId}/documents/search`, "GET", {
      yearStart,
      yearEnd,
      type,
      offset,
      limit,
    });
  };

  return { results, searchCompanyDocs, isSearching };
};
